const actionsSecEl = document.querySelector('.actions-sec');

if (actionsSecEl) {
  const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            import('./gradient.component.js').then(({ Gradient }) => {
              const gradient = new Gradient();
              gradient.initGradient('#gradient-canvas-actions');
            });

            obs.disconnect();
          }
        });
      },
      { threshold: 0.1 }
  );

  observer.observe(actionsSecEl);
}